import './gallery.css';

import { contents } from './contents';
import ProductionImages from './production-images';
import { useEffect, useState } from 'react';

function getTags() {
  const tags = new Set();
  contents.forEach((c) => {
    c.tags.forEach((l) => tags.add(l));
  });
  return [...tags].sort();
}
const tagList = getTags();

const Gallery = () => {
  const [productions, setProductions] = useState(contents);
  const [filterTag, setFilterTag] = useState(null);

  useEffect(() => {
    if (!filterTag) {
      setProductions(contents);
    } else {
      const prods = contents.filter((c) => c.tags.includes(filterTag));
      setProductions(prods);
    }
  }, [filterTag]);

  function onFilter(tag) {
    setFilterTag(tag);
  }

  return (
    <>
      <h2>Directing Portfolio</h2>
      <label style={{ marginRight: 4 }}>Filter By</label>
      {tagList.map((tag) => (
        <button key={tag} className="filterBtn" data-selected={filterTag === tag} onClick={() => onFilter(tag)}>
          {tag}
        </button>
      ))}
      <button className="filterBtn" data-selected={!filterTag} onClick={() => onFilter()}>
        All Shows
      </button>
      <div className="gallery-links">
        {productions.map((show) => (
          <a rel="contents" href={`#${show.refId}`} key={show.refId}>
            <img src={show.showThumbnail} width="200px" alt={show.name} />
            <br />
            {show.shortName || show.name}
          </a>
        ))}
      </div>
      {productions.map((show) => (
        <ProductionImages key={show.refId} {...show} />
      ))}
    </>
  );
};
export default Gallery;
